import { FleekError } from './FleekError';

type Application = {
  id?: string;
  name?: string;
};

type ApplicationNotFoundErrorOptions = {
  application: Application;
};

export class ApplicationNotFoundError extends FleekError<ApplicationNotFoundErrorOptions> {
  public name = 'ApplicationNotFoundError';

  toString = () => 'Application not found.';
}
